import { render, staticRenderFns } from "./PreorderDetail.vue?vue&type=template&id=154aae6c&"
import script from "./PreorderDetail.vue?vue&type=script&lang=js&"
export * from "./PreorderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports